export default "__VITE_ASSET__DW7JKWzd__ 480w, __VITE_ASSET__DeMa26N8__ 768w, __VITE_ASSET__CwyWq$pd__ 1200w, __VITE_ASSET__D$Uph47V__ 1920w";